(function() {
  'use strict';

  // Configuration
  const COLOR_VARIANT_NAMES = ['Color', 'Farbe'];
  const SIZE_VARIANT_NAMES = ['Größe', 'Size'];

  // Store original checkout buttons HTML
  let originalCheckoutButtons = new Map();
  let originalDynamicCheckoutButtons = new Map();

  /**
   * Get variant option by name (case-insensitive)
   */
  function getVariantOption(item, possibleNames) {
    if (!item.options_with_values) return null;
    
    for (let option of item.options_with_values) {
      if (possibleNames.some(name => name.toLowerCase() === option.name.toLowerCase())) {
        return option.value;
      }
    }
    return null;
  }

  /**
   * Check if cart violates the rules
   */
  function isCartBlocked(cartData) {
    // Group items by product ID
    const productGroups = {};
    
    cartData.items.forEach(item => {
      if (!productGroups[item.product_id]) {
        productGroups[item.product_id] = [];
      }
      productGroups[item.product_id].push(item);
    });

    // Check each product group for violations
    for (let productId in productGroups) {
      const items = productGroups[productId];
      
      // Group by color
      const colorGroups = {};
      let hasNoColorItems = false;
      
      items.forEach(item => {
        const color = getVariantOption(item, COLOR_VARIANT_NAMES);
        const size = getVariantOption(item, SIZE_VARIANT_NAMES);
        
        if (!color) {
          hasNoColorItems = true;
          if (!colorGroups['NO_COLOR']) {
            colorGroups['NO_COLOR'] = [];
          }
          colorGroups['NO_COLOR'].push({ size, item });
        } else {
          if (!colorGroups[color]) {
            colorGroups[color] = [];
          }
          colorGroups[color].push({ size, item });
        }
      });

      // Rule 4: Block if no color is specified and multiple sizes exist
      if (hasNoColorItems && colorGroups['NO_COLOR']) {
        const sizes = colorGroups['NO_COLOR'].map(entry => entry.size).filter(s => s);
        const uniqueSizes = [...new Set(sizes)];
        if (uniqueSizes.length > 1) {
          console.log('Cart blocked: Multiple sizes for product without color');
          return true;
        }
      }

      // Check each color group
      for (let color in colorGroups) {
        if (color === 'NO_COLOR') continue;
        
        const colorItems = colorGroups[color];
        const sizes = colorItems.map(entry => entry.size).filter(s => s);
        const uniqueSizes = [...new Set(sizes)];
        
        // Rule 1: Block if same color has multiple different sizes
        if (uniqueSizes.length > 1) {
          console.log(`Cart blocked: Multiple sizes (${uniqueSizes.join(', ')}) for same color (${color})`);
          return true;
        }
      }
    }

    return false;
  }

  /**
   * Save original state of checkout buttons
   */
  function saveOriginalButtons() {
    const checkoutButtons = document.querySelectorAll('#checkout, [id="checkout"]');
    checkoutButtons.forEach(button => {
      if (!originalCheckoutButtons.has(button)) {
        originalCheckoutButtons.set(button, {
          element: button.cloneNode(true),
          parent: button.parentNode
        });
      }
    });

    const dynamicCheckoutButtons = document.querySelectorAll('.cart__dynamic-checkout-buttons');
    dynamicCheckoutButtons.forEach(element => {
      if (!originalDynamicCheckoutButtons.has(element)) {
        originalDynamicCheckoutButtons.set(element, element.style.display);
      }
    });
  }

  /**
   * Replace checkout buttons with alert message
   */
  function blockCheckout() {
    saveOriginalButtons();
    
    const checkoutButtons = document.querySelectorAll('#checkout, [id="checkout"]');
    
    checkoutButtons.forEach(button => {
      // Skip if already replaced
      if (button.classList.contains('cart-blocked-alert')) return;
      
      // Create alert message
      const alert = document.createElement('div');
      alert.className = 'cart-blocked-alert';
      alert.style.cssText = `
        padding: 15px;
        background-color: #f44336;
        color: white;
        border-radius: 4px;
        text-align: center;
        font-weight: bold;
        margin: 10px 0;
      `;
      alert.textContent = 'Aktuell nehmen wir leider keine Bestellungen mit mehreren Größen des selben Produkts oder der selben Farbe entgegen. Bitte passe deinen Warenkorb an um mit deiner Bestellung fortzufahren.';
      
      // Replace button with alert
      button.parentNode.replaceChild(alert, button);
    });
    
    // Hide dynamic checkout buttons
    const dynamicCheckoutButtons = document.querySelectorAll('.cart__dynamic-checkout-buttons');
    dynamicCheckoutButtons.forEach(element => {
      element.style.display = 'none';
    });
  }

  /**
   * Restore checkout buttons
   */
  function restoreCheckout() {
    // Remove alert messages
    const alerts = document.querySelectorAll('.cart-blocked-alert');
    alerts.forEach(alert => {
      const saved = Array.from(originalCheckoutButtons.values()).find(
        saved => saved.parent === alert.parentNode
      );
      if (saved) {
        alert.parentNode.replaceChild(saved.element.cloneNode(true), alert);
      } else {
        alert.remove();
      }
    });

    // Restore dynamic checkout buttons
    const dynamicCheckoutButtons = document.querySelectorAll('.cart__dynamic-checkout-buttons');
    dynamicCheckoutButtons.forEach(element => {
      const originalDisplay = originalDynamicCheckoutButtons.get(element);
      element.style.display = originalDisplay || '';
    });

    // Clear saved states
    originalCheckoutButtons.clear();
    originalDynamicCheckoutButtons.clear();
  }

  /**
   * Main function to check cart and apply rules
   */
  async function checkCart() {
    try {
      // Fetch cart data from Shopify Cart API
      const response = await fetch('/cart.js');
      const cartData = await response.json();
      
      console.log('Cart data:', cartData);
      
      // Check if cart should be blocked
      if (isCartBlocked(cartData)) {
        blockCheckout();
      } else {
        restoreCheckout();
      }
    } catch (error) {
      console.error('Error checking cart:', error);
    }
  }

  // Run check when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkCart);
  } else {
    checkCart();
  }

  // Also run check when cart is updated (if using Shopify's cart events)
  document.addEventListener('cart:updated', checkCart);
  
  // Listen for any AJAX cart updates
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const promise = originalFetch.apply(this, args);
    
    // Re-check cart after any cart API calls
    if (args[0] && (args[0].includes('/cart/') || args[0].includes('/cart.js'))) {
      promise.then(() => {
        setTimeout(checkCart, 100);
      });
    }
    
    return promise;
  };

  // Listen for cart changes using MutationObserver (for themes that update cart without AJAX)
  const observer = new MutationObserver(() => {
    checkCart();
  });

  // Observe cart container for changes
  const cartObserverInit = () => {
    const cartContainers = document.querySelectorAll('[data-cart], .cart, #cart');
    cartContainers.forEach(container => {
      observer.observe(container, {
        childList: true,
        subtree: true
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cartObserverInit);
  } else {
    cartObserverInit();
  }
})();